/// <amd-module name="Build/Admin/Common/TaskAgentPoolUtils" />
import { equals } from "VSS/Core/Util/String";
import { IdentityRef } from "VSS/Platform/Contracts/WebApi";

import { TaskAgentPool, TaskAgentPoolReference, TaskAgentPoolOptions } from "DistributedTask/Client/Contracts/TaskAgent";

const hostedServiceAccountName: string = "Microsoft.VisualStudio.Services.TFS";
const onPremServiceAccountName: string = "Microsoft.TeamFoundation.System";
const azurePipelinesOwnerName: string = "Azure Pipelines";

export function isHostedOrPoolProviderBacked(pool: TaskAgentPool | undefined): boolean {
    if (!pool) {
        return false;
    }
    return pool.isHosted || pool.agentCloudId > 0;
}

export function isElastic(pool: TaskAgentPoolReference | undefined): boolean {
    if (!pool || !pool.options) {
        return false;
    }
    return (pool.options & TaskAgentPoolOptions.ElasticPool) === TaskAgentPoolOptions.ElasticPool;
}

/**
 * Returns whether or not Agents should be visible for the given pool. Agents should be visible for pools which contain
 * physical agents, like private pools. Agents should also be visible for hosted pools where virtual agents or slots have
 * settings, like capabilities.
 */
export function showPoolAgents(pool: TaskAgentPool | undefined): boolean {
    // Private pool provider backed pools do not have agents to manage, so do not show agents
    if (pool &&
        !pool.isHosted &&
        pool.agentCloudId) {
        return false;
    }

    return true;
}

/**
 * Returns whether or not Agent Specs should be shown for a given pool. Only certain pools have well enough defined agent specs
 * that we can show in UI.
 */
export function showPoolAgentSpecs(pool: TaskAgentPool | undefined): boolean {
    // Non-legacy hosted pools backed by a pool provider have a defined agent spec that we can show in the UI.
    if (pool &&
        pool.isHosted &&
        !pool.isLegacy &&
        pool.agentCloudId) {
        return true;
    }

    return false;
}

/**
 * Gets a friendly display name from a provided IdentityRef object
 */
export function getPoolOwnerDisplayName(identity: IdentityRef): string {
    const { displayName } = identity;
    if (displayName) {
        // Some pools that are provisioned on the user's behalf have a system account owner string
        // We will find those instances and replace it with "Azure Pipelines"
        if (equals(displayName, hostedServiceAccountName, true) ||
            equals(displayName, onPremServiceAccountName, true)) {
            return azurePipelinesOwnerName;
        }
        else {
            return displayName;
        }
    }
    else {
        return "";
    }
}
